import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { AceitarProposta } from 'src/app/aplicacao/models/aceitar-proposta.model';
import { OffcanvasService } from 'src/app/shared/services/offcanvas.service';
import { LIMITES_CARACTERES } from 'src/app/aplicacao/helper/limites-caracteres.const';

@Component({
  selector: 'app-formulario-aceitar-proposta',
  templateUrl: './formulario-aceitar-proposta.component.html',
  styleUrls: ['./formulario-aceitar-proposta.component.scss']
})
export class FormularioAceitarPropostaComponent {
  @Input() propostaId;
  @Output() onSubmitSuccess: EventEmitter<any> = new EventEmitter();
  @Output() onClickFechar: EventEmitter<any> = new EventEmitter();
  model = new AceitarProposta();
  validarFormulario = true;

  subscrition = new Subscription();

  constructor( private offcanvasService: OffcanvasService ) {}

  ngOnInit() {
    this.subscrition = this.offcanvasService.aoFecharOffcanvas.subscribe({
      next: () => this.limparFormulario()
    });
  }

  ngOnDestroy() {
    this.subscrition.unsubscribe();
  }

  limparFormulario() {
    this.model = new AceitarProposta()
  }

  enviar(): void {
    this.model.asForm.controls.propostaId.setValue(this.propostaId);
    if(this.model.form.valid) {
      this.validarFormulario = true;
      this.onSubmitSuccess.emit(this.model.form.value);
      this.limparFormulario();
    } else {
      this.validarFormulario = false;
    }
  }

  fechar(){
    this.onClickFechar.emit(true);
    this.limparFormulario();
  }

  protected readonly LIMITES_CARACTERES = LIMITES_CARACTERES;
}
